export * from "/__w/wiggot-web/wiggot-web/packages/web-components/store/modals-services/modal-complete-profile.ts"